import { inject, makeStateKey, TransferState } from "@angular/core";
import {TServiceResult} from "@shared/helper/t-service-result";
import {PageList} from "@shared/model/categoryAndSearch/pageList-model";
import {IClubCourseAggregateModel} from "@app/pages/clubs/models/club-course-aggregate-model";
import { ResolveFn} from "@angular/router";
import {of, switchMap} from "rxjs";
import {LocalRepository} from "@shared/helper/local-repository";
import {ClubAggregatorService} from "@app/pages/clubs/services/club-aggregator.service";
import { TermFilterModel } from "@shared/model/categoryAndSearch/term-filter-model";

export const STATE_KEY_COURSES = makeStateKey<CoursesResolverData>("STATE_KEY_COURSES");

export const CoursesResolver: ResolveFn<CoursesResolverData> = (route, state) => {
    const termFilters = new TermFilterModel();

    const _localRepository: LocalRepository = inject(LocalRepository);
    const serverState: TransferState = inject(TransferState);
    const clubAggregatorService: ClubAggregatorService = inject(ClubAggregatorService);
    if (_localRepository.IsInBrowser) {
        clubAggregatorService.getClubCourses(route.paramMap.get('id')!, termFilters)
            .pipe(switchMap(res => {
                serverState.set(STATE_KEY_COURSES, res);
                return of(res);
            }));
    }

    return of(serverState.get(STATE_KEY_COURSES, TServiceResult.fromFailure<any>(null)));
}

export type CoursesResolverData = TServiceResult<PageList<IClubCourseAggregateModel>>;
